import {forwardRef, memo, useCallback, useEffect, useImperativeHandle, useRef, useState} from 'react';
import sdk from '@/sdk';
import routers, {buildPath} from '@/config/routers';
import {getPersonalHomeSubInfo} from '@/store';
import {useHistory} from 'react-router';
// import GuideBase from '../GuideBase';
import MessageContainer from '../MessageContainer';
import {GRAY_RELEASE_KEYS, initGray} from '@/grayRelease';
import * as store from '@/store';
import {isUndefined} from 'lodash-es';
import {IPublishListData} from '@/interface';

interface IPersonalPageGuide {
    children: any;
    publishDocDialogProps?: {guideType: number, sceneInfo: IPublishListData[]};
}

const PersonalPageGuide = memo(forwardRef(({children, publishDocDialogProps}: IPersonalPageGuide, ref: any) => {
    const history = useHistory();
    const [isShow, changeIsShow] = useState(false);

    const handleConfirmJump = useCallback(() => {
        // 在功能未解锁弹窗上点击「去使用知识星」
        let url = '';
        const {spaceGuid = '', groupGuid = '', repositoryGuid = ''} = sdk.as.userRepository || {};
        const {
            squareRecommendAccess,
        } = getPersonalHomeSubInfo();
        if (squareRecommendAccess) {
            url = buildPath(routers.Knowledge.squareDocRootPath, {
                spaceGuid: spaceGuid,
                groupGuid: groupGuid,
                repositoryGuid: repositoryGuid,
            });
            window.location.href = url;
        } else {
            history.push(routers.Home.path);
        }
    }, [history]);

    const closeEffect = async () => {
        await sdk.as.updateNewGuide({
            knowledgeCoinPersonalPageIsRead: true,
        });
        changeIsShow(false);
    };

    // notBtn，非新手引导的Confirm按钮触发了close方法
    const close = useCallback(async (notBtn?: boolean) => {
        if (sdk.as.user?.settings?.newGuide?.knowledgeCoinPersonalPageIsRead) {
            return;
        }

        await closeEffect();

        // 新手引导的按钮触发了close方法
        !notBtn && handleConfirmJump();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const cancel = async () => {
        await closeEffect();
    };

    useImperativeHandle(ref, () => ({
        onAction: () => {
            // 非新手引导Confirm触发Close
            close(true);
        },
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }), [isShow]);

    async function checkShouldShowNewGuide() {
        const knowledgeCoinPersonalPageIsRead = sdk.as.user?.settings?.newGuide?.knowledgeCoinPersonalPageIsRead;
        // 说明是第一次出现
        if (knowledgeCoinPersonalPageIsRead) {
            return;
        }
        changeIsShow(true);
    }
    useEffect(() => {
        // 个人主页公开文档发布小流量下线
        if (isUndefined(publishDocDialogProps) || publishDocDialogProps?.guideType) {
            changeIsShow(false);
        } else {
            checkShouldShowNewGuide();
        }
        // if (isGray) {
        //     if (isUndefined(publishDocDialogProps) || publishDocDialogProps?.guideType) {
        //         changeIsShow(false);
        //     } else {
        //         checkShouldShowNewGuide();
        //     }
        // } else {
        //     checkShouldShowNewGuide();
        // }
    }, [publishDocDialogProps]);

    return isShow ?
        <div style={{position: 'relative'}}>
            <MessageContainer
                title="阅读文档获得可用知识币哦"
                content="您可以在文档底部给优秀文档赠送知识币，这是对创作者的鼓励和认可哦～"
                onChangeVisible={changeIsShow}
                onClickButtonToClose={close}
                buttonContent="去赠送"
                name="personalPageGuide"
                onClickCancel={cancel}
            >{children}</MessageContainer>
        </div>
        : <>{children}</>;
}));

export default store.connect([
    store.KEYS.PUBLISH_DOC_DIALOG_PROPS,
])(PersonalPageGuide);

